import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AppInfo } from '../../shared/app-info';

/**
 * YSTM footer component
 */
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        MatButtonModule,
        RouterLink
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  protected readonly currentYear = signal(new Date().getFullYear());
  public readonly appVersion = AppInfo.version;
}
